import { render, staticRenderFns } from "./moduleright.vue?vue&type=template&id=6f4a7e68&scoped=true&"
import script from "./moduleright.vue?vue&type=script&lang=js&"
export * from "./moduleright.vue?vue&type=script&lang=js&"
import style0 from "./moduleright.vue?vue&type=style&index=0&id=6f4a7e68&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.10.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f4a7e68",
  null
  
)

export default component.exports